import { render, staticRenderFns } from "./ViParentSchoolOverview.vue?vue&type=template&id=41cbf98a&scoped=true"
import script from "./ViParentSchoolOverview.vue?vue&type=script&lang=js"
export * from "./ViParentSchoolOverview.vue?vue&type=script&lang=js"
import style0 from "./ViParentSchoolOverview.vue?vue&type=style&index=0&id=41cbf98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cbf98a",
  null
  
)

export default component.exports